.insight {
  margin: 0;

  u {
    color: var(--link);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    &:active {
      color: var(--link-active);
    }
  }
}

.li {
  display: flex;
  gap: 0.75rem;
  align-items: center;

  @media (--sm-down) {
    align-items: flex-start;
  }
}

.link {
  padding-right: 2rem;
  line-height: 1.2;
  color: inherit;
  text-wrap: balance;

  &:hover {
    text-decoration: none;
  }
}

.list {
  flex: 1;
  padding: 0;
  margin: 0;
  margin-bottom: 0 !important;
  list-style-type: none;

  & > * + * {
    margin-top: 0.5rem;
  }
}
